import { Grid, Badge } from "@mui/material"
import Dropdown from "react-multilevel-dropdown"
import { currentUser, getBrowserLang } from "../../constants/utils"
import { labels } from "../../constants/labels"
import { FAQ_RELEASE_NOTE } from "../../constants/values"
import { styled } from "@mui/material/styles"
import { useQuery, useMutation, gql } from "@apollo/client"
import { HelpOutline, FiberManualRecord } from "@mui/icons-material"
import moment from "moment"
const { VITE_APP_FAQ_RELEASE_DOWNLOAD } = import.meta.env

const StyledBadge = styled(Badge)({
    position: "relative",
    width: "1.5em",
})

const UpdateBtn = styled(FiberManualRecord)({
    fontSize: "0.7em",
    position: "absolute",
    left: "1.5em",
    top: "0px",
    bottom: "0.6em",
    color: "rgb(0, 125, 186)",
})

const Link = styled("a")({
    textDecoration: "none",
    color: "#000",
})

const faqBackClass = "faq-back"
const boldLinkClass = "bold-link"
const downloadLinkClass = "download-link"
const notDownloadLinkClass = "not-download-link"

const styles = `
    .${faqBackClass} {
        background-color: white !important;
    }
    .${boldLinkClass} {
        font-weight: bold;
        color: #000;
    }
    .${downloadLinkClass} {
        text-decoration: none;
        color: #000 !important;
        display: block;
        border-bottom: 1px solid #babfc7;
        font-weight: normal;
    }
    .${notDownloadLinkClass} {
        text-decoration: none;
        font-weight: bold;
        color: #000 !important;
        display: block;
        background-color: #eee;
        border-bottom: 1px solid #babfc7;
    }
`

const NOTIFICATION_ACK = gql`
    mutation notification_ack($object: sdm_notifications_ack_insert_input!) {
        insert_sdm_notifications_ack_one(object: $object) {
            created_at
            id
            notification_id
            user_ack
        }
    }
`
const NOTIFICATION_QUERY = gql`
    query notifications($module: String, $user: String, $is_enabled: Boolean) {
        sdm_notifications(
            where: {
                _and: [
                    {
                        module: { _eq: $module }
                        is_enabled: { _eq: $is_enabled }
                    }
                ]
            }
        ) {
            id
            client_id
            module
            created_at
            type
            data
            is_enabled
        }
        sdm_notifications_ack(where: { user_ack: { _eq: $user } }) {
            id
            notification_id
            user_ack
        }
    }
`

const FAQ_RELEASE_DATA = {}
const NOTIFICATION_IDS = []
const DISPLAYED_NOTIFICATION_IDS = []

export default function FaqReleaseNote() {
    const current_user = currentUser()

    const current_user_email =
        current_user && Object.keys(current_user).length
            ? current_user.email
            : ""

    const { loading, error, data } = useQuery(NOTIFICATION_QUERY, {
        variables: {
            module: "RVP",
            is_enabled: true,
            user: current_user_email,
        },
        pollInterval: 1000 * 1800,
    })

    const [mutateNotification, response] = useMutation(NOTIFICATION_ACK)

    let show_new_notification = false
    let show_new_faq = false
    let show_new_release_note = false

    if (!loading && !error && data)
        data.sdm_notifications_ack.forEach((item) => {
            if (!NOTIFICATION_IDS.includes(item.notification_id))
                NOTIFICATION_IDS.push(item.notification_id)
        })

    if (
        !response.loading &&
        response.data &&
        Object.keys(response.data.insert_sdm_notifications_ack_one).length
    ) {
        NOTIFICATION_IDS.push(
            response.data.insert_sdm_notifications_ack_one.notification_id
        )
    }

    !loading &&
        !error &&
        data &&
        data.sdm_notifications.forEach((row) => {
            if (!FAQ_RELEASE_DATA[row.type]) FAQ_RELEASE_DATA[row.type] = []
            if (
                FAQ_RELEASE_DATA[row.type] &&
                getBrowserLang().toLowerCase() === row.data.lang.toLowerCase()
            ) {
                if (!NOTIFICATION_IDS.includes(row.id)) {
                    show_new_notification = true
                    if (row.type === FAQ_RELEASE_NOTE.FAQ) {
                        show_new_faq = true
                    } else if (row.type === FAQ_RELEASE_NOTE.RELEASE_NOTE) {
                        show_new_release_note = true
                    }
                }

                if (
                    FAQ_RELEASE_DATA[row.type] &&
                    !DISPLAYED_NOTIFICATION_IDS.includes(row.id)
                ) {
                    DISPLAYED_NOTIFICATION_IDS.push(row.id)
                    FAQ_RELEASE_DATA[row.type].push({
                        client_id: row.client_id,
                        id: row.id,
                        data: row.data,
                        createdAt: row.created_at,
                    })
                }
            }
        })

    return (
        <>
            <style>{styles}</style>
            <Grid item>
                <Dropdown
                    buttonClassName={faqBackClass}
                    title={
                        <StyledBadge data-test="faq-note-btn">
                            <HelpOutline />

                            {show_new_notification && <UpdateBtn />}
                        </StyledBadge>
                    }
                >
                    {Object.keys(FAQ_RELEASE_DATA).length &&
                        Object.keys(FAQ_RELEASE_DATA).map((item, k) => (
                            <Dropdown.Item
                                data-test={item}
                                key={k}
                                className={
                                    item === FAQ_RELEASE_NOTE.FAQ &&
                                    show_new_faq
                                        ? boldLinkClass
                                        : item ===
                                                FAQ_RELEASE_NOTE.RELEASE_NOTE &&
                                            show_new_release_note
                                          ? boldLinkClass
                                          : ""
                                }
                            >
                                {item === FAQ_RELEASE_NOTE.FAQ
                                    ? labels.common.faq
                                    : labels.common.releasenotes}
                                {FAQ_RELEASE_DATA[item].length > 0 && (
                                    <Dropdown.Submenu>
                                        {FAQ_RELEASE_DATA[item]
                                            .sort(
                                                (a, b) =>
                                                    moment(b.createdAt) -
                                                    moment(a.createdAt)
                                            )
                                            .map((sub, i) => (
                                                <Dropdown.Item
                                                    key={i}
                                                    data-test={item}
                                                    className={
                                                        NOTIFICATION_IDS.includes(
                                                            sub.id
                                                        )
                                                            ? downloadLinkClass
                                                            : notDownloadLinkClass
                                                    }
                                                >
                                                    <Link
                                                        href={`${VITE_APP_FAQ_RELEASE_DOWNLOAD}${sub.data.filename}`}
                                                        onClick={() => {
                                                            if (
                                                                !NOTIFICATION_IDS.includes(
                                                                    sub.id
                                                                )
                                                            ) {
                                                                mutateNotification(
                                                                    {
                                                                        variables:
                                                                            {
                                                                                object: {
                                                                                    notification_id:
                                                                                        sub.id,
                                                                                    user_ack:
                                                                                        current_user_email,
                                                                                },
                                                                            },
                                                                    }
                                                                )
                                                            }
                                                        }}
                                                    >
                                                        {sub.data.label}
                                                    </Link>
                                                </Dropdown.Item>
                                            ))}
                                    </Dropdown.Submenu>
                                )}
                            </Dropdown.Item>
                        ))}
                </Dropdown>
            </Grid>
        </>
    )
}
